import { useQuery } from '@tanstack/vue-query';
import { bookingsService } from '@/api/bookings.service';

export function useBookingJobs(bookingId: string) {
  return useQuery({
    queryKey: ['booking-jobs', bookingId],
    queryFn: () => bookingsService.getJobs(bookingId),
  });
}
